import React from 'react';
import PropTypes from 'prop-types';

import { EVENT_ADDON_ITEMS_META } from '../../../views/AlbumFolder/FreemiumEventCreateWizard/constants';
import CheckmarkIcon from '../../../../../components/icons/CheckmarkIcon';
import Button from '../../../../../components/global/Button';
import { EVENT_ADDON_ITEM_INFORMATION } from '../../FreemiumEventPurchase/components/EventAddonItemInformationModal';
import InfoCircleIcon from '../../../../../components/icons/InfoCircleIcon';
import useOpenModal from '../../../../../hooks/useOpenModal';

const propTypes = {
  features: PropTypes.object,
};

const EventAddonItemFeatures = ({ features }) => {
  const openModal = useOpenModal();

  return (
    <ul className="event-addon-item-features feature-list text-md">
      {features.map(feature => {
        const featureMeta = EVENT_ADDON_ITEMS_META[feature?.id];

        return (
          <li
            key={feature?.id ?? feature}
            className="px-0 d-flex align-items-center"
          >
            <CheckmarkIcon
              color="#E09D3C"
              size="18px"
              className="feature-icon"
            />
            <span>{feature?.label ?? feature}</span>
            {featureMeta?.howItWorks && (
              <Button
                btnStyle="reset"
                onClick={() => {
                  openModal(EVENT_ADDON_ITEM_INFORMATION, {
                    title: feature.label,
                    ...featureMeta?.howItWorks,
                  });
                }}
                className="ml-1"
              >
                <InfoCircleIcon size={14} />
              </Button>
            )}
          </li>
        );
      })}
    </ul>
  );
};

EventAddonItemFeatures.propTypes = propTypes;

export default EventAddonItemFeatures;
